<template>
  <div>
    <div v-for="(item, i) in list" :key="i" class="update_item">
      <div class="row">
        <span class="drug_name" :class="{ mdrug: ['4'].includes(prescripType) }">
          {{ item.commonName || item.drugName }}
        </span>
        <div class="delete_btn" @click="deleteDrug(i)">
          <span>删除</span>
        </div>
      </div>
      <div v-if="item.isLack" class="understock">
        <span>库存不足</span>
      </div>
      <!-- 1: 中成  2: 西  4: 蒙  3、5、6: 中草药等-->
      <!-- <uni-list-item
        v-if="['1', '2', '4', '8'].includes(prescripType)"
        title="药品用法："
        :show-arrow="true"
        :clickable="true"
        :right-text="
          getKeyValueText(
            isMeng ? 'drug_usage_meng_his' : 'drug_usage_his',
            item.drugUsage
          ) || '请选择'
        "
        @click="
          changeDrugUsage(
            isMeng ? 'drug_usage_meng_his' : 'drug_usage_his',
            'drugUsage',
            i
          )
        "
      /> -->

      <uni-list-item
        v-if="['4'].includes(prescripType)"
        title="药品用法"
        :right-text="getKeyValueText('drug_usage_meng_his', item.drugUsage) || '请选择药品用法'"
        :show-arrow="true"
        :clickable="true"
        :code="'drug_usage_meng_his'"
        @click="changeDicValue('drug_usage_meng_his', 'drugUsage', i)"
      ></uni-list-item>

      <ms-select-dicNew
        v-if="['1', '2', '8'].includes(prescripType)"
        :code="'drug_usage_his'"
        :title="'药品用法'"
        v-model:rightText="item.drugUsage"
        :parnetIndex="i"
        parnetDataKey="drugUsage"
        :uniListTop="true"
        @pickerChange="changeDicPopup"
      ></ms-select-dicNew>

      <ms-select-dicNew
        v-if="['1', '2', '8'].includes(prescripType)"
        :code="'frequence_his'"
        :title="'用药次数'"
        v-model:rightText="item.frequence"
        :parnetIndex="i"
        parnetDataKey="frequence"
        :uniListTop="true"
        @pickerChange="changeDicPopup"
      ></ms-select-dicNew>

      <uni-list-item
        v-if="['4'].includes(prescripType)"
        title="用药时间"
        :right-text="getKeyValueText('drug_use_time', item.useDrugTime) || '请选择用药时间'"
        :show-arrow="true"
        :clickable="true"
        @click="changeDicValue('drug_use_time', 'useDrugTime', i)"
      ></uni-list-item>

      <uni-list-item
        v-if="['4'].includes(prescripType)"
        :title="'是否药引：'"
        :show-arrow="false"
        :clickable="true"
        :show-switch="true"
        switch-type="checkbox"
        :curIndex="i"
        :switch-checked="!!item.isDrugInducer && item.isDrugInducer !== '0'"
        @switchChange="switchChange"
        @click="clickSwitch(i)"
      />

      <div class="input_wrap">
        <span class="input_title">单次剂量</span>
        <div class="input_row">
          <input
            v-model="item.useAuantity"
            type="digit"
            placeholder="请输入单次剂量"
            placeholder-style="color:#CECECE;font-size:.64rem"
            placeholder-class="input-placeholder"
            class="input_con"
            @input="inputUseAuantity(item.useAuantity, i)"
          />
          <span class="unit" :class="{ mdrug: ['4'].includes(prescripType) }">
            {{ getKeyValueText(isMeng ? 'measure_unit_meng' : 'measure_unit', item.measureUnit) }}
          </span>
        </div>
      </div>
      <ms-select-dicNew
        v-if="['3', '5', '6'].includes(prescripType)"
        :code="'prescrip_desc'"
        :title="'药品说明'"
        :right-text="item.drugDesc"
        :uniListTop="true"
        @changeDicValue="
          changeDicValue('prescrip_desc', 'drugDesc', i, item.drugDesc ? true : false)
        "
      ></ms-select-dicNew>

      <div v-if="['1', '2', '4', '8'].includes(prescripType)" class="input_wrap">
        <span class="input_title">用药天数</span>
        <div class="input_row">
          <input
            v-model="item.useDays"
            type="number"
            placeholder="请输入用药天数"
            placeholder-style="color:#CECECE;font-size:.64rem"
            placeholder-class="input-placeholder"
            class="input_con"
            @input="inputUseDays(item.useDays, i)"
          />
          <span :class="{ mdrug: ['4'].includes(prescripType) }" class="unit">
            {{ isMeng ? '' : '天' }}
          </span>
        </div>
      </div>

      <div v-if="['1', '2', '4', '8'].includes(prescripType)" class="input_wrap">
        <span class="input_title">发药数量</span>
        <div class="input_row">
          <input
            v-model="item.amount"
            type="number"
            placeholder="请输入发药数量"
            placeholder-style="color:#CECECE;font-size:.64rem"
            placeholder-class="input-placeholder"
            class="input_con"
          />
          <span :class="{ mdrug: ['4'].includes(prescripType) }" class="unit">
            {{ getKeyValueText(isMeng ? 'package_unit_meng' : 'package_unit', item.packageUnit) }}
          </span>
        </div>
      </div>

      <div v-if="['1', '2', '4', '8'].includes(prescripType)" class="input_wrap">
        <span class="input_title">嘱托</span>
        <div class="input_row">
          <input
            v-model="item.attention"
            type="text"
            placeholder="请输入嘱托"
            placeholder-style="color:#CECECE;font-size:.64rem"
            placeholder-class="input-placeholder"
            class="input_con"
          />
        </div>
      </div>
    </div>

    <uni-popup ref="prescripTipPop">
      <div class="popup-wrap">
        <div class="content-wrap">
          <span class="theSon">{{ codeDesc }}</span>
        </div>
        <div class="have-know" @click="haveKnow">
          <span>我知道了</span>
        </div>
      </div>
    </uni-popup>
    <ms-select-dicValue
      ref="dicPopup"
      :code="code"
      v-model:visible="showDicValue"
      :field="field"
      :isHave="isHave"
      :value="selectDicValue"
      @change="setDicValue"
    ></ms-select-dicValue>
  </div>
</template>

<script>
import { getKeyValueText, getBusinessValue, getKeyValue } from '@/views/funcPuzzle/utils/util.js'
import { mapState } from 'vuex'
import { aCheckDrugStock } from '@/views/funcPuzzle/utils/index.js'
import msSelectDicValue from '@/views/funcPuzzle/components/ms-select-dicValue/ms-select-dicValue.vue'
import MsSelectDicNew from '@/views/funcPuzzle/components/ms-select-dicNew/ms-select-dicNew.vue'

export default {
  components: {
    'ms-select-dicValue': msSelectDicValue,
    'ms-select-dicNew': MsSelectDicNew
  },
  props: {
    drugList: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    prescripType: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    prescripClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    isMeng() {
      return this.prescripType === '4'
    },
    selectDicValue() {
      if (!this.list[this.selectedIndex] || this.list[this.selectedIndex].length === 0) {
        return []
      }
      return this.list[this.selectedIndex][this.field]
    },
    ...mapState(['hospitalInfo'])
  },
  data() {
    return {
      showDicPopup: false,
      showUseDrugTimePopup: false,
      codeDesc: '',
      showPrescripDesc: false,
      list: [
        {
          hospitalID: '',
          visitID: '',
          drugID: '',
          refDrugID: '',
          drugName: '',
          drugSpec: '',
          drugPrice: '',
          drugUsage: '',
          frequence: '',
          mindoseUnit: '',
          useAuantity: '',
          useDays: '',
          amount: '',
          attention: '',
          useDrugTime: '',
          isDrugInducer: '0',
          drugFlag: ''
        }
      ],
      selectedIndex: '',
      showDrugUsage: false,
      showFrequence: false,
      drugMsg: '',
      searchDrugList: [],
      showMdrugUsage: false,
      code: '',
      field: '',
      showDicValue: false,
      isHave: false,
      limitConfig: null,
      curIndex: 0,
      isInducer: ''
    }
  },
  watch: {
    prescripType: {
      handler(val) {},
      immediate: true
    },
    modelValue: {
      handler(val) {
        if (!val) {
          this.list = [{}]
        } else {
          this.list = val
        }
      },
      deep: true,
      immediate: true
    },
    list: {
      handler(val) {
        this.$emit('update:modelValue', val)
      },
      deep: true
    },
    showDicValue(val) {}
  },
  mounted() {
    this.fetchDrugDaysConfig()
  },
  methods: {
    getKeyValueText,
    getBusinessValue,
    getKeyValue,
    clickUseDrugTime() {},
    // changeDicValue(code, value, i, isHave) {
    //   this.field = value
    //   this.code = code
    //   this.isHave = isHave
    //   this.selectedIndex = i
    // },
    changeDicValue(code, value, i, isHave) {
      this.field = value
      this.code = code
      this.isHave = isHave
      this.selectedIndex = i
      setTimeout(_ => {
        this.$refs.dicPopup.open()
      }, 0)
    },
    changeDicPopup({ val, parnetIndex, targetKey }) {
      console.log('val', val)
      if (parnetIndex) {
        this.list[parnetIndex][targetKey] = val
      }
      console.log('list', this.list)
    },
    changeDrugUsage(code, value, i, isHave) {
      this.changeDicValue(code, value, i, isHave)
      setTimeout(_ => {
        this.$refs.dicPopup.open()
        this.showDicPopup = true
      }, 0)
    },
    changeUseDrugTime(code, value, i, isHave) {
      this.changeDicValue(code, value, i, isHave)
      setTimeout(_ => {
        this.$refs.useDrugTimePopup.open()
        this.showUseDrugTimePopup = true
      }, 0)
    },
    haveKnow() {
      this.$refs.prescripTipPop.close()
    },
    clickSwitch(i) {
      this.curIndex = i
      this.list[this.curIndex].isDrugInducer = this.isInducer ? '1' : '0'
    },
    switchChange(e) {
      this.isInducer = e.value
    },
    deleteDicValue(val, field) {
      this.list[this.selectedIndex][field] = ''
      this.$refs.dicPopup.close()
    },

    deleteDrug(i) {
      this.list.splice(i, 1)
    },

    setDicValue(val, field) {
      console.log('setDicValue')
      console.log('val', val)
      console.log('field', field)
      this.list[this.selectedIndex][field] = val

      this.checkDrugStock(
        this.list[this.selectedIndex].drugID,
        this.list[this.selectedIndex].drugName,
        this.list[this.selectedIndex].drugType,
        this.list[this.selectedIndex].amount,
        this.list[this.selectedIndex].warehouseID
      )
    },
    setDrugUsage(val) {
      this.setDicValue(val, 'drugUsage')
    },
    setUseDrugTime(val) {
      this.setDicValue(val, 'useDrugTime')
    },
    inputUseDays(useDays, i) {
      this.checkDays(useDays)

      this.selectedIndex = i

      console.log(this.getBusinessValue(this.list[this.selectedIndex].frequence), 'useDays2')

      this.list[this.selectedIndex].amount = Math.ceil(
        (useDays *
          this.getBusinessValue(this.list[this.selectedIndex].frequence) *
          this.list[this.selectedIndex].useAuantity) /
          (this.list[this.selectedIndex].drugItem.mindoseUnit *
            this.list[this.selectedIndex].drugItem.packageNumber)
      )

      this.checkDrugStock(
        this.list[this.selectedIndex].drugID,
        this.list[this.selectedIndex].drugName,
        this.list[this.selectedIndex].drugType,
        this.list[this.selectedIndex].amount,
        this.list[this.selectedIndex].warehouseID
      )
    },
    // calcAmount
    inputUseAuantity(useAuantity, i) {
      this.selectedIndex = i
      this.list[this.selectedIndex].amount = Math.ceil(
        (this.list[this.selectedIndex].useDays *
          this.getBusinessValue(this.list[this.selectedIndex].frequence) *
          useAuantity) /
          (this.list[this.selectedIndex].drugItem.mindoseUnit *
            this.list[this.selectedIndex].drugItem.packageNumber)
      )

      this.checkDrugStock(
        this.list[this.selectedIndex].drugID,
        this.list[this.selectedIndex].drugName,
        this.list[this.selectedIndex].drugType,
        this.list[this.selectedIndex].amount,
        this.list[this.selectedIndex].warehouseID
      )
    },
    // 用药天数校验提示
    checkDays(useDays) {
      if (this.limitConfig) {
        if (useDays > this.limitConfig.days) {
          uni.showToast({
            title: `用药天数超过${this.limitConfig.days}天`,
            icon: 'none'
          })
          return false
        }
      }
      // let maps = {
      //   '2': 3,
      //   '1': 7,
      //   '3': 7
      // }

      // if (
      //   (this.prescripClass === '2' ||
      //     this.prescripClass === '1' ||
      //     this.prescripClass === '3') &&
      //   useDays > maps[this.prescripClass]
      // ) {
      //   uni.showToast({
      //     title: '用药天数超过处方规定',
      //     icon: 'none'
      //   })
      // }
    },
    // 库存校验提示
    checkDrugStock(drugID, drugName, drugType, count, warehouseID) {
      const params = {
        drugs: [{ drugId: drugID, drugName, drugType, amount: count, warehouseID }],
        flag: '1'
      }
      aCheckDrugStock(params).then(rs => {
        if (rs.DrugList && rs.DrugList[0] && parseInt(rs.DrugList[0].stockQuantity) < count) {
          uni.showToast({
            title: '药品库存不足',
            icon: 'none'
          })
        } else if ([-1, -2].includes(rs.code) && !rs.DrugList) {
          this.codeDesc = rs.codeDesc || rs.msg
          // 失败弹窗提示
          this.prescripTipOpen()
          return false
        }
      })
    },
    prescripTipOpen() {
      this.$refs.prescripTipPop.open()
    },
    // 获取用药天数限制的配置
    fetchDrugDaysConfig() {
      try {
        const config = localStorage.getItem('UseDrugDaysConfig')
        if (config) {
          this.limitConfig = JSON.parse(config)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.update_item {
  min-height: 5.333333rem;
  // padding: .682667rem;
  box-sizing: border-box;
  border-bottom: 0.021333rem solid #ececec;
  .row {
    padding: 0.682667rem 0.682667rem 0.426667rem 0.682667rem;
    display: flex;
    justify-content: space-between;
    .drug_name {
      font-size: 0.64rem;
      font-weight: 500;
      color: #222222;
    }
    .delete_btn {
      width: 2.133333rem;
      height: 0.981333rem;
      background: #ff7555;
      border-radius: 0.085333rem;
      text-align: center;
      line-height: 0.981333rem;
      font-size: 0.64rem;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .understock {
    margin-bottom: 0.512rem;
    font-size: 0.512rem;
    font-weight: 400;
    color: #ff7555;
    padding-left: 0.682667rem;
  }
  .input_wrap {
    display: flex;
    padding: 0.682667rem;
    align-items: center;
    justify-content: space-between;
    height: 0.810667rem;
    border-top: 0.021333rem solid #ececec;
    .input_title {
      font-size: 0.64rem;
      font-weight: 400;
      color: #888;
    }
    .input_row {
      display: flex;
      width: 6.4rem;
      height: 100%;
      align-items: center;
      .input_con {
        text-align: right;
      }
      .unit {
        margin-left: 0.213333rem;
      }
    }
  }
}
.popup-wrap {
  width: 10.666667rem;
  min-height: 5.546667rem;
  border-radius: 0.341333rem;
  padding: 0.64rem 0.64rem 2.773333rem 0.64rem;
  background-color: #fff;
  font-size: 0.512rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #444444;
  line-height: 0.810667rem;
  overflow: hidden;
  position: relative;

  .title-wrap {
    width: 100%;
    height: 1.92rem;
    text-align: center;
    line-height: 1.92rem;
    font-size: 0.768rem;
    color: #222222;
    font-weight: 600;
  }

  .umbra {
    position: absolute;
    bottom: 3.84rem;
    left: 0rem;
    width: 100%;
    height: 0.426667rem;
    background-color: rgba(255, 255, 255, 0.5);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }

  .content-wrap {
    height: auto;
    color: #222222;
    font-size: 0.64rem;
    margin-top: 0.426667rem;
    text-align: center;
    overflow-y: scroll;
    max-height: 17.066667rem;
    .common {
      word-wrap: break-word;
    }
  }
  .have-know {
    width: 6.4rem;
    height: 1.706667rem;
    text-align: center;
    line-height: 1.706667rem;
    color: #0089ff;
    border-radius: 0.853333rem;

    border: 0.021333rem solid #0089ff;
    position: absolute;
    left: 2.56rem;
    bottom: 0.768rem;
  }
  .protocol {
    width: 100%;
    height: 1.450667rem;
    display: flex;
    align-items: center;
    .protocol-text {
      font-size: 0.512rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888;
    }
  }
}
</style>
